import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { CaptionText } from '@paypalcorp/pp-react';
import RenderSwitchComponent from '../../switchPanels/SwitchPanel';
import BasicInputField from '../../../shared/fields/BasicInputField';
import { MessageFormat } from '@paypalcorp/worldready';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';

const renderNoteTextField = (props) => {
  return <BasicInputField {...props} />;
};

function Note({ isChecked, showBadge, dispatch }) {
  const worldReady = useContext(WorldReadyContext);

  const title = new MessageFormat(worldReady, {
    id: 'buttonsV3.note.title',
  }).format();

  const subTitle = new MessageFormat(worldReady, {
    id: 'buttonsV3.note.subTitle',
  }).format();

  const textLabel = new MessageFormat(worldReady, {
    id: 'buttonsV3.note.textLabel',
  }).format();

  return (
    <div className="note">
      <Field
        id="isNoteEnabled"
        name="noNote"
        label="isNoteEnabled"
        title={title}
        subTitle={subTitle}
        component={RenderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
        showBadge={showBadge}
      />
      {isChecked ? (
        <>
          <Field
            id="noteLabel"
            name="noteLabel"
            type="text"
            component={renderNoteTextField}
            label={textLabel}
            validateOnChange={true}
          />
          <CaptionText className="note-info">
            <Message id="buttonsV3.note.textInfo" />
          </CaptionText>
        </>
      ) : null}
    </div>
  );
}

Note.propTypes = {
  isChecked: PropTypes.bool,
  dispatch: PropTypes.func,
  showBadge: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(null, mapDispatchToProps)(Note);
